// app/javascript/controllers/checkbox_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "selectAll"];

  // When "select all" is clicked
  toggleAll(event) {
    const checked = event.target.checked;
    this.itemTargets.forEach((cb) => (cb.checked = checked));
  }

  // When any individual checkbox is clicked
  updateSelectAll() {
    const allChecked =
      this.itemTargets.length > 0 && this.itemTargets.every((cb) => cb.checked);
    this.selectAllTarget.checked = allChecked;
  }

  // On Submit button click
  submitForm(event) {
    event.preventDefault();

    const selectedIds = this.itemTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value);

    if (selectedIds.length === 0) {
      alert("Please select at least one record to export.");
      return;
    }

    const baseUrl = event.currentTarget.getAttribute("href");
    const url = new URL(baseUrl, window.location.origin);

    // Add selected_ids[]=... params
    selectedIds.forEach((id) => {
      url.searchParams.append("selected_ids[]", id);
    });

    // Redirect to export URL
    window.location.href = url.toString();
  }
}
